import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';
import { InputSize } from '../textInput';

const getSpinnersWidthForInputSize = (inputSize: InputSize): number => {
  switch (inputSize) {
    case InputSize.Small:
      return 20;

    default:
      return 32;
  }
};

export const inputStyle = css({
  width: '100%',
  boxSizing: 'border-box',
  padding: '0 0 0 8px',
});

export const suffixWrapperStyle = ({ inputSize }: { inputSize: InputSize }) => (theme: Theme) => css({
  display: 'flex',
  height: '100%',
  borderStyle: 'solid',
  borderColor: theme.borderColors.primary,
  borderWidth: '0 0 0 1px',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0 4px 4px 0',
  boxSizing: 'border-box',
  width: getSpinnersWidthForInputSize(inputSize),
  flexShrink: 0,
});
